import { render, staticRenderFns } from "./SkillTable.vue?vue&type=template&id=2c2b0ba1&scoped=true"
import script from "./SkillTable.vue?vue&type=script&lang=js"
export * from "./SkillTable.vue?vue&type=script&lang=js"
import style0 from "./SkillTable.vue?vue&type=style&index=0&id=2c2b0ba1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b0ba1",
  null
  
)

export default component.exports